export interface ShowFilterStoreType {
  showFilter: boolean;
}

export enum ShowFilterStoreKind {
  INITIAL = 'INITIAL',
}

export interface ShowFilterStoreAction {
  type: ShowFilterStoreKind;
  payload: ShowFilterStoreType;
}
